var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "21px",
    viewBox: "0 0 17 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/notification profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification-creation-vertical",
    transform: "translate(-974.000000, -467.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-rule",
    transform: "translate(119.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "action-copy-2",
    transform: "translate(822.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(12.000000, 329.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy-3",
    transform: "translate(21.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/notification-profile",
    transform: "translate(0.324000, 0.542000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3665437,13.8499385 L16.4329643,15.9163592 L16.4329643,16.9249692 L-2.30926389e-14,16.9249692 L-2.30926389e-14,15.9163592 L2.06642066,13.8499385 L2.06642066,8.75768758 C2.06642066,7.15046347 2.46822066,5.76466347 3.27183272,4.600246 C4.09184502,3.40302804 5.23164502,2.62402804 6.69126691,2.26322263 L6.69126691,1.5498155 C6.69126691,1.1234091 6.83886691,0.758509102 7.13407134,0.455104551 C7.42927577,0.1517 7.79007577,-3.12134395e-15 8.21648216,0 C8.64288856,-3.12134395e-15 9.00778856,0.1517 9.31119311,0.455104551 C9.61459766,0.758509102 9.76629766,1.1234091 9.76629766,1.5498155 L9.76629766,2.26322263 C11.2095193,2.62402804 12.3411193,3.41122804 13.1611316,4.62484625 C13.9647437,5.78926371 14.3665437,7.16686371 14.3665437,8.75768758 L14.3665437,13.8499385 Z M8.21648216,20 C7.64247355,20 7.15457355,19.8032 6.75276753,19.4095941 C6.3509615,19.0159882 6.1500615,18.5403882 6.1500615,17.9827798 L10.2829028,17.9827798 C10.2829028,18.5403882 10.0779028,19.0159882 9.66789668,19.4095941 C9.25789053,19.8032 8.77409053,20 8.21648216,20 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconBlack);
export default __webpack_public_path__ + "static/media/notification_icon_black.b42fd90b162320462ecc5f6205982c4f.svg";
export { ForwardRef as ReactComponent };